module.exports = __webpack_public_path__ + "img/icon-step-2.1b07a393.svg";